import React from "react";
import { Link } from "react-router";
import ImageIdecaba from "../assets/logo-idecba.png";
import "../styles/Header.css";
import SearchBar from "../components/SearchBar";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../redux/authSlice";
import packageJson from "./../../package.json";
import ProtectedLink from "./ProtectedLink";
import { getEnv } from "../config";

function Header() {
  const version = packageJson.version;
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const allowedRoles = ["admin", "q"];
  const hasAllowedRole = user?.role?.some((role) =>
    allowedRoles.includes(role)
  );
  const authState = JSON.parse(localStorage.getItem("auth"));

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  return (
    <>
      {isAuthenticated ? (
        <header className="o-header navbar" role="banner">
          <Link to="/" className="skip-to-main-content-link">
            Saltar al contenido principal
          </Link>
          <div className="container header-container">
            <Link
              to="/"
              className="navbar-brand position-relative d-inline-block"
            >
              <img
                className="img-header-logo"
                src={ImageIdecaba}
                alt="Gobierno de la Ciudad de Buenos Aires - Inicio"
              />
              <span
                className="position-absolute start-100 bottom-0 translate-middle-x text-muted bg-white px-1 rounded small"
                style={{ transform: "translate(-50%, 10%)" }}
              >
                {version}
              </span>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarContent3"
              aria-controls="navbarContent3"
              aria-expanded="false"
              aria-label="Menú"
            ></button>
            <div className="collapse navbar-collapse" id="navbarContent3">
              <div className="navbar-content">
                <div className="navbar-sections">
                  <nav>
                    <div className="navbar-sections-title">
                      <div
                        className="me-2 my-2 mx-2 bg-light  p-1"
                        style={{ textAlign: "end" }}
                      >
                        <p className="mb-0 fw-bold">
                          {authState?.usuario?.nombre}&nbsp;
                          {authState?.usuario?.apellido}{" "}
                        </p>
                        <p className="mb-0 text-muted">
                          CUIL: {authState?.usuario?.cuil}
                        </p>
                      </div>
                    </div>
                    <p className="navbar-sections-title">Secciones</p>
                    <ul className="nav nav-pills nav-sections">
                      <li className="dropdown">
                        <button
                          type="button"
                          className="btn btn-dropdown btn-lg"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="btn-dropdown-text ellipsis-1">
                            Institucional
                          </span>
                          <span
                            className="material-symbols-rounded btn-dropdown-icon"
                            aria-label="hidden"
                          >
                            expand_more
                          </span>
                        </button>
                        <div className="dropdown-menu">
                          <Link
                            className="dropdown-item"
                            to="Institucional/IDECABA"
                          >
                            <span className="item-text">¿Qué es IDECABA?</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Institucional/Organizacion"
                          >
                            <span className="item-text">Organización</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Institucional/Normativas"
                          >
                            <span className="item-text">Normativas</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Institucional/Organismos-Participantes"
                          >
                            <span className="item-text">
                              Organismos participantes
                            </span>
                          </Link>
                          {/* <Link className="dropdown-item" to="Institucional/Adherirse-IDECABA">
                    <span className="item-text">¿Cómo adherirse a IDECABA?</span>
                    </Link> */}
                        </div>
                      </li>

                      <li className="dropdown">
                        <button
                          type="button"
                          className="btn btn-dropdown btn-lg"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="btn-dropdown-text ellipsis-1">
                            Recursos
                          </span>
                          <span
                            className="material-symbols-rounded btn-dropdown-icon"
                            aria-label="hidden"
                          >
                            expand_more
                          </span>
                        </button>
                        <div className="dropdown-menu">
                          <Link
                            className="dropdown-item"
                            to="Recursos/Visor-de-Mapas"
                          >
                            <span className="item-text">Visor de mapas</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Recursos/Geoservicios"
                          >
                            <span className="item-text">Geoservicios</span>
                          </Link>
                          <a
                            href={getEnv("REACT_APP_GEONETWORK_URL")}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="dropdown-item"
                          >
                            <span className="item-text">
                              Catálogo de metadatos
                            </span>
                          </a>
                          <Link
                            className="dropdown-item"
                            to="Recursos/Catalogo-de-Objetos-Geograficos"
                          >
                            <span className="item-text">
                              Catálogo de Objetos Geográficos (OG)
                            </span>
                          </Link>
                          {/* <Link className="dropdown-item" to="Recursos/Instructivos">
                    <span className="item-text">Instructivos</span>
                    </Link> */}
                          <Link
                            className="dropdown-item"
                            to="Institucional/Normativas"
                          >
                            <span className="item-text">
                              Normativas y estándares
                            </span>
                          </Link>
                        </div>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link nav-link-lg" to="/Contacto">
                          <span>Contacto</span>
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div className="navbar-search">
                  <SearchBar />
                </div>
                <div className="navbar-user">
                  <div className="dropdown">
                    <button
                      type="button"
                      className="btn btn-dropdown btn-lg btn-dropdown-border notification"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span
                        className="material-symbols-rounded"
                        aria-hidden="true"
                      >
                        person
                      </span>
                      <span className="btn-dropdown-text ellipsis-1"></span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end">
                      <div
                        className="me-2 my-2 mx-2 bg-light  p-1"
                        style={{ textAlign: "end" }}
                      >
                        <p className="mb-0 fw-bold">
                          {authState?.usuario?.nombre}&nbsp;
                          {authState?.usuario?.apellido}{" "}
                        </p>
                        <p className="mb-0 text-muted">
                          CUIL: {authState?.usuario?.cuil}
                        </p>
                      </div>
                      <ProtectedLink
                        funcionalidadesRequeridas={[
                          "Crear Novedad",
                          "Editar Novedad",
                          "Ver Novedad",
                          "Eliminar Novedad",
                          "Crear Geoservicio",
                          "Editar Geoservicio",
                          "Ver Geoservicio",
                          "Eliminar Geoservicio",
                        ]}
                      >
                        <p className="d-flex justify-content-center my-4 mx-4 bg-light  p-1">
                          Administración de Secciones
                        </p>
                      </ProtectedLink>
                      <ProtectedLink
                        funcionalidadesRequeridas={[
                          "Crear Novedad",
                          "Editar Novedad",
                          "Ver Novedad",
                          "Eliminar Novedad",
                        ]}
                      >
                        <Link className="dropdown-item" to="/Novedades">
                          <span className="item-text">Novedades</span>
                        </Link>
                      </ProtectedLink>
                      <ProtectedLink
                        funcionalidadesRequeridas={[
                          "Crear Geoservicio",
                          "Editar Geoservicio",
                          "Ver Geoservicio",
                          "Eliminar Geoservicio",
                        ]}
                      >
                        <Link
                          className="dropdown-item"
                          to="Recursos/Geoservicios"
                        >
                          <span className="item-text">Geoservicios</span>
                        </Link>
                      </ProtectedLink>
                      <ProtectedLink
                        funcionalidadesRequeridas={[
                          "Crear Usuario",
                          "Editar Usuario",
                          "Ver Usuario",
                          "Eliminar Usuario",
                          "Crear Perfil",
                          "Editar Perfil",
                          "Ver Perfil",
                          "Eliminar Perfil",
                        ]}
                      >
                        <div className="d-flex justify-content-center my-2 mx-2 bg-light  p-1">
                          <span>Seguridad</span>
                        </div>
                      </ProtectedLink>
                      <div
                        className="border-top"
                        style={{ borderWidth: "8px", borderColor: "#007bff" }}
                      ></div>
                      <ProtectedLink
                        funcionalidadesRequeridas={[
                          "Crear Usuario",
                          "Editar Usuario",
                          "Ver Usuario",
                          "Eliminar Usuario",
                        ]}
                      >
                        <Link className="dropdown-item" to="Seguridad/Usuarios">
                          <span className="item-text"> Usuarios</span>
                        </Link>
                      </ProtectedLink>
                      <ProtectedLink
                        funcionalidadesRequeridas={[
                          "Crear Perfil",
                          "Editar Perfil",
                          "Ver Perfil",
                          "Eliminar Perfil",
                        ]}
                      >
                        <Link className="dropdown-item" to="Seguridad/Perfiles">
                          <span className="item-text"> Perfiles</span>
                        </Link>
                      </ProtectedLink>
                      <div
                        className="border-top my-2 mx-2"
                        style={{ borderWidth: "8px", borderColor: "#007bff" }}
                      ></div>
                      <button
                        className="dropdown-item item-danger"
                        onClick={handleLogout}
                      >
                        <span className="item-text">Cerrar sesión</span>
                        <span
                          className="material-symbols-rounded"
                          aria-hidden="true"
                        >
                          logout
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="navbar-user-mobile">
                <nav>
                  <p className="navbar-user-mobile-title"></p>
                  <ProtectedLink
                    funcionalidadesRequeridas={[
                      "Crear Novedad",
                      "Editar Novedad",
                      "Ver Novedad",
                      "Eliminar Novedad",
                      "Crear Geoservicio",
                      "Editar Geoservicio",
                      "Ver Geoservicio",
                      "Eliminar Geoservicio",
                    ]}
                  >
                    <p className="d-flex justify-content-center my-4 mx-4 bg-light  p-1">
                      Administración de Secciones
                    </p>
                  </ProtectedLink>
                  <ul className="nav flex-column nav-pills nav-user">
                    <ProtectedLink
                      funcionalidadesRequeridas={[
                        "Crear Novedad",
                        "Editar Novedad",
                        "Ver Novedad",
                        "Eliminar Novedad",
                      ]}
                    >
                      <li className="nav-item">
                        <Link className="dropdown-item" to="/Novedades">
                          <span className="item-text">Novedades</span>
                        </Link>
                      </li>
                    </ProtectedLink>
                    <ProtectedLink
                      funcionalidadesRequeridas={[
                        "Crear Geoservicio",
                        "Editar Geoservicio",
                        "Ver Geoservicio",
                        "Eliminar Geoservicio",
                      ]}
                    >
                      <li className="nav-item">
                        <Link
                          className="dropdown-item"
                          to="Recursos/Geoservicios"
                        >
                          <span className="item-text">Geoservicios</span>
                        </Link>
                      </li>
                    </ProtectedLink>
                    <ProtectedLink
                      funcionalidadesRequeridas={[
                        "Crear Usuario",
                        "Editar Usuario",
                        "Ver Usuario",
                        "Eliminar Usuario",
                        "Crear Perfil",
                        "Editar Perfil",
                        "Ver Perfil",
                        "Eliminar Perfil",
                      ]}
                    >
                      <div className="d-flex justify-content-center my-2 mx-2 bg-light  p-1">
                        <span>Seguridad</span>
                      </div>
                    </ProtectedLink>
                    <div
                      className="border-top"
                      style={{ borderWidth: "8px", borderColor: "#007bff" }}
                    ></div>
                    <ProtectedLink
                      funcionalidadesRequeridas={[
                        "Crear Usuario",
                        "Editar Usuario",
                        "Ver Usuario",
                        "Eliminar Usuario",
                      ]}
                    >
                      <li className="nav-item">
                        <Link className="dropdown-item" to="Seguridad/Usuarios">
                          <span className="item-text"> Usuarios</span>
                        </Link>
                      </li>
                    </ProtectedLink>
                    <ProtectedLink
                      funcionalidadesRequeridas={[
                        "Crear Perfil",
                        "Editar Perfil",
                        "Ver Perfil",
                        "Eliminar Perfil",
                      ]}
                    >
                      <li className="nav-item">
                        <Link className="dropdown-item" to="Seguridad/Perfiles">
                          <span className="item-text"> Perfiles</span>
                        </Link>
                      </li>
                    </ProtectedLink>
                    <div
                      className="border-top my-2 mx-2"
                      style={{ borderWidth: "8px", borderColor: "#007bff" }}
                    ></div>
                    <li className="nav-item">
                      <button
                        className="dropdown-item item-danger"
                        onClick={handleLogout}
                      >
                        <span className="item-text">Cerrar sesión</span>
                        <span
                          className="material-symbols-rounded"
                          aria-hidden="true"
                        >
                          logout
                        </span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div className="header-backdrop"></div>
        </header>
      ) : (
        <header className="o-header navbar" role="banner">
          <Link to="/" className="skip-to-main-content-link">
            Saltar al contenido principal
          </Link>
          <div className="container header-container">
            <Link
              to="/"
              className="navbar-brand position-relative d-inline-block"
            >
              <img
                className="img-header-logo"
                src={ImageIdecaba}
                alt="Gobierno de la Ciudad de Buenos Aires - Inicio"
              />
              <span
                className="position-absolute start-100 bottom-0 translate-middle-x text-muted bg-white px-1 rounded small"
                style={{ transform: "translate(-50%, 10%)" }}
              >
                {version}
              </span>
            </Link>
            <div className="navbar-login-mobile">
              <Link
                className="btn btn-lg btn-icon btn-outline-tertiary"
                to="/Login"
              >
                <span className="material-symbols-rounded" aria-hidden="true">
                  person
                </span>
                <span className="btn-text">Ingresar</span>
              </Link>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarContent1"
              aria-controls="navbarContent1"
              aria-expanded="false"
              aria-label="Menú"
            ></button>
            <div className="collapse navbar-collapse" id="navbarContent1">
              <div className="navbar-content">
                <div className="navbar-sections">
                  <nav>
                    <p className="navbar-sections-title">Secciones</p>
                    <ul className="nav nav-pills nav-sections">
                      <li className="dropdown">
                        <button
                          type="button"
                          className="btn btn-dropdown btn-lg"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="btn-dropdown-text ellipsis-1">
                            Institucional
                          </span>
                          <span
                            className="material-symbols-rounded btn-dropdown-icon"
                            aria-label="hidden"
                          >
                            expand_more
                          </span>
                        </button>
                        <div className="dropdown-menu">
                          <Link
                            className="dropdown-item"
                            to="Institucional/IDECABA"
                          >
                            <span className="item-text">¿Qué es IDECABA?</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Institucional/Organizacion"
                          >
                            <span className="item-text">Organización</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Institucional/Normativas"
                          >
                            <span className="item-text">Normativas</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Institucional/Organismos-Participantes"
                          >
                            <span className="item-text">
                              Organismos participantes
                            </span>
                          </Link>
                          {/* <Link className="dropdown-item" to="Institucional/Adherirse-IDECABA">
                    <span className="item-text">¿Cómo adherirse a IDECABA?</span>
                    </Link> */}
                        </div>
                      </li>

                      <li className="dropdown">
                        <button
                          type="button"
                          className="btn btn-dropdown btn-lg"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="btn-dropdown-text ellipsis-1">
                            Recursos
                          </span>
                          <span
                            className="material-symbols-rounded btn-dropdown-icon"
                            aria-label="hidden"
                          >
                            expand_more
                          </span>
                        </button>
                        <div className="dropdown-menu">
                          <Link
                            className="dropdown-item"
                            to="Recursos/Visor-de-Mapas"
                          >
                            <span className="item-text">Visor de mapas</span>
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="Recursos/Geoservicios"
                          >
                            <span className="item-text">Geoservicios</span>
                          </Link>
                          <a
                            href={getEnv("REACT_APP_GEONETWORK_URL")}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="dropdown-item"
                          >
                            <span className="item-text">
                              Catálogo de metadatos
                            </span>
                          </a>
                          <Link
                            className="dropdown-item"
                            to="Recursos/Catalogo-de-Objetos-Geograficos"
                          >
                            <span className="item-text">
                              Catálogo de Objetos Geográficos (OG)
                            </span>
                          </Link>
                          {/* <Link className="dropdown-item" to="Recursos/Instructivos">
                    <span className="item-text">Instructivos</span>
                    </Link> */}
                          <Link
                            className="dropdown-item"
                            to="Institucional/Normativas"
                          >
                            <span className="item-text">
                              Normativas y estándares
                            </span>
                          </Link>
                        </div>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link nav-link-lg" to="/Contacto">
                          <span>Contacto</span>
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>

                <div className="navbar-search">
                  <SearchBar />
                </div>
                <div className="navbar-login">
                  <Link className="btn btn-lg btn-outline-tertiary" to="/Login">
                    <span
                      className="material-symbols-rounded"
                      aria-hidden="true"
                    >
                      person
                    </span>
                    <span className="btn-text">Ingresar</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="header-backdrop"></div>
        </header>
      )}
    </>
  );
}

export default Header;
